export enum EStepStatus {
    default, active, disabled
}